/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 派工管理頁面
 * @module DispatchManagementContainer
 */

// ----- import from local libraries -----
import {
  React,
  PropTypes,
  connect,
  BaseComponent,
  AccessModeEnums,
} from '../../components/BaseComponent';

// ----- import from local components -----
import Header from '../../features/main-frame/components/Header';
import Footer from '../../features/main-frame/components/Footer';
import Sidebar from '../../features/main-frame/components/Sidebar';
import {useSelector} from 'react-redux';
import DispatchManagementPage from './components/DispatchManagementPage';
import {useState} from 'react';
import DispatchHistoryModel from './components/DispatchHistoryModel';
import AssignmentReportPreviewModal from './components/AssignmentReportPreviewModal';
import AssignmnetOrderEditModal from './components/AssignmentOrderEditModal';

// ----- constants and enums -----

const DispatchManagementContainer = (props) => {
  const userPermissions = useSelector((state) =>
    JSON.parse(state.access.userPermissions),
  );
  const [isOpen, onOpenChange] = useState(false);
  const [searchId, setSearchId] = useState(null);
  const [currentStartTime, setCurrentStartTime] = useState(null);
  const [currentEndTime, setCurrentEndTime] = useState(null);
  const [previewAssignment, setPreviewAssignment] = useState(null);
  const [editOrderAssignment, setEditOrderAssignment] = useState(null);
  const [isDataNeedsReload, setIsDataNeedsReload] = useState(false);
  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <DispatchManagementPage
            showModel={(isShow) => onOpenChange(isShow)}
            setSearchId={(id) => setSearchId(id)}
            setCurrentStartTime={(time) => setCurrentStartTime(time)}
            setCurrentEndTime={(time) => setCurrentEndTime(time)}
            setPreviewAssignment={(data) => setPreviewAssignment(data)}
            setEditOrderAssignment={(data) => setEditOrderAssignment(data)}
            isReload={isDataNeedsReload}
            isReloadDone={() => setIsDataNeedsReload(false)}
            {...props}
          />
          <DispatchHistoryModel
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            searchId={searchId}
            currentStartTime={currentStartTime}
            currentEndTime={currentEndTime}
          />
          <AssignmentReportPreviewModal assignment={previewAssignment} />
          <AssignmnetOrderEditModal
            assignment={editOrderAssignment}
            reloadData={() => setIsDataNeedsReload(true)}
          />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default DispatchManagementContainer;
